import GoogleMapsLoader from "google-maps";

GoogleMapsLoader.KEY = "AIzaSyBmtTC7CLTLJQp1pPQ72MVC6IxVKjyzL1c";
GoogleMapsLoader.VERSION = "3.34";

const style = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#212121",
      },
    ],
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#212121",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e",
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#bdbdbd",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#181818",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#1b1b1b",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#2c2c2c",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#8a8a8a",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#373737",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#3c3c3c",
      },
    ],
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [
      {
        color: "#4e4e4e",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#3d3d3d",
      },
    ],
  },
];

// {
//   zoomControl: boolean,
//   mapTypeControl: boolean,
//   scaleControl: boolean,
//   streetViewControl: boolean,
//   rotateControl: boolean,
//   fullscreenControl: boolean
// }
const zoom = 16;
const options = [
  {
    center: { lat: 51.511921022359466, lng: -0.12586880021169977 },
    zoom: zoom,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    rotateControl: false,
    styles: style,
  },
  {
    center: { lat: 53.47893, lng: -2.23902 },
    zoom: zoom,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    rotateControl: false,
    styles: style,
  },
  {
    center: { lat: 45.467574105239684, lng: 9.183339276267803 },
    zoom: zoom,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    rotateControl: false,
    styles: style,
  },
  {
    center: { lat: 40.7593131, lng: -73.9804262 },
    zoom: zoom,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    rotateControl: false,
    styles: style,
  },
];

export default class maps {
  constructor() {
    this.maps = document.querySelectorAll(".map-link");
    GoogleMapsLoader.load(
      function (google) {
        this.loadMaps(google);
      }.bind(this)
    );
  }

  loadMaps = (google) => {
    for (let index = 0; index < this.maps.length; index++) {
      const element = this.maps[index];
      let map = new google.maps.Map(element, options[index]);
      let marker = new google.maps.Marker({
        position: options[index].center,
        icon: "/img/maps.svg",
        map: map,
      });
    }
  };
}
